// extracted by mini-css-extract-plugin
export default {"imageSection":"ImageSection_imageSection__j-NaZ","wordRank":"ImageSection_wordRank__xjLVy","moreOptions":"ImageSection_moreOptions__zyTYH","close":"ImageSection_close__1hy9s"};